module.exports = __webpack_public_path__ + "546c365bf42cc9d45e98ae651673870f.pdf";